Reflect.defineProperty(Comment.prototype, "jsonData", {
    get() {
        try {
            let content = this.data.trim().replace(/^(?:<!)?\[CDATA\[/, '').replace(/\]\](?:>)?$/, '').trim();
            return JSON.parse(content);
        }
        catch(e) { }
    }
});